export const GET_BALANCE="GET_BALANCE"

export const GET_BALANCE_REQUEST="GET_BALANCE_REQUEST"
export const GET_BALANCE_SUCCESS="GET_BALANCE_SUCCESS"
export const GET_BALANCE_FAILUER="GET_BALANCE_FAILUER"